export default {
  badge: 'Značka',
  open: 'Odpri',
  close: 'Zapri',
  dismiss: 'Opusti',
  confirmEdit: {
    ok: 'V redu',
    cancel: 'Prekliči',
  },
  dataIterator: {
    noResultsText: 'Ni iskanega zapisa',
    loadingText: 'Nalaganje ...',
  },
  dataTable: {
    itemsPerPageText: 'Vrstic na stran:',
    ariaLabel: {
      sortDescending: 'Razvrščeno padajoče.',
      sortAscending: 'Razvrščeno naraščajoče.',
      sortNone: 'Ni razvrščeno.',
      activateNone: 'Aktivirajte za odstranitev razvrščanja.',
      activateDescending: 'Aktivirajte za padajoče razvrščanje.',
      activateAscending: 'Aktivirajte za naraščajoče razvrščanje.',
    },
    sortBy: 'Razvrsti po',
  },
  dataFooter: {
    itemsPerPageText: 'Elementov na stran:',
    itemsPerPageAll: 'Vsi',
    nextPage: 'Naslednja stran',
    prevPage: 'Prejšnja stran',
    firstPage: 'Prva stran',
    lastPage: 'Zadnja stran',
    pageText: '{0}-{1} od {2}',
  },
  dateRangeInput: {
    divider: 'do',
  },
  datePicker: {
    itemsSelected: '{0} izbranih',
    range: {
      title: 'Izberite datume',
      header: 'Vnesite datume',
    },
    title: 'Izberite datum',
    header: 'Vnesite datum',
    input: {
      placeholder: 'Vnesite datum',
    },
    ariaLabel: {
      previousMonth: 'Prejšnji mesec',
      nextMonth: 'Naslednji mesec',
      selectYear: 'Izberite leto',
      previousYear: 'Prejšnje leto',
      nextYear: 'Naslednje leto',
      selectMonth: 'Izberite mesec',
      selectDate: '{0}',
      currentDate: 'Danes, {0}',
    },
  },
  noDataText: 'Ni podatkov',
  carousel: {
    prev: 'Prejšnji prikaz',
    next: 'Naslednji prikaz',
    ariaLabel: {
      delimiter: 'Prikaz {0} od {1}',
    },
  },
  calendar: {
    moreEvents: 'Še {0}',
    today: 'Danes',
  },
  input: {
    clear: 'Počisti {0}',
    prependAction: 'Dejanje pred {0}',
    appendAction: 'Dejanje po {0}',
    otp: 'Vnesite {0}. OTP znak',
  },
  fileInput: {
    counter: '{0} datotek',
    counterSize: '{0} datotek (skupno {1})',
  },
  fileUpload: {
    title: 'Povlecite in spustite datoteke tukaj',
    divider: 'ali',
    browse: 'Prebrskaj datoteke',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
    title: 'Izberite čas',
    hour: 'Ura',
    minute: 'Minute',
    second: 'Sekunde',
    notAllowed: 'Vrednost ni dovoljena',
  },
  pagination: {
    ariaLabel: {
      root: 'Navigacija po straneh',
      next: 'Naslednja stran',
      previous: 'Prejšnja stran',
      page: 'Pojdi na stran {0}',
      currentPage: 'Trenutna stran, stran {0}',
      first: 'Prva stran',
      last: 'Zadnja stran',
    },
  },
  stepper: {
    next: 'Naprej',
    prev: 'Nazaj',
  },
  rating: {
    ariaLabel: {
      item: 'Ocena {0} od {1}',
    },
  },
  loading: 'Nalaganje ...',
  infiniteScroll: {
    loadMore: 'Naloži več',
    empty: 'Konec',
  },
  rules: {
    required: 'To polje je obvezno',
    email: 'Vnesite veljaven e-poštni naslov',
    number: 'To polje lahko vsebuje samo številke',
    integer: 'To polje lahko vsebuje samo cela števila',
    capital: 'To polje lahko vsebuje samo velike črke',
    maxLength: 'Vnesti morate največ {0} znakov',
    minLength: 'Vnesti morate najmanj {0} znakov',
    strictLength: 'Dolžina vnesenega polja ni veljavna',
    exclude: 'Znak {0} ni dovoljen',
    notEmpty: 'Izberite vsaj eno vrednost',
    pattern: 'Neveljaven format',
  },
  command: {
    search: 'Vnesite ukaz ali iščite...',
  },
  hotkey: {
    then: 'nato',
    ctrl: 'Ctrl',
    command: 'Command',
    shift: 'Shift',
    alt: 'Alt',
    option: 'Option',
    enter: 'Enter',
    escape: 'Escape',
    upArrow: 'Puščica gor',
    downArrow: 'Puščica dol',
    leftArrow: 'Puščica levo',
    rightArrow: 'Puščica desno',
    backspace: 'Backspace',
    space: 'Presledek',
    plus: 'plus',
    shortcut: 'Tipkovnična bližnjica: {0}',
    or: 'ali',
  },
  video: {
    play: 'Predvajaj',
    pause: 'Zaustavi',
    seek: 'Išči',
    volume: 'Glasnost',
    showVolume: 'Prikaži nadzor glasnosti',
    mute: 'Utišaj',
    unmute: 'Vklopi zvok',
    enterFullscreen: 'Celozaslonski način',
    exitFullscreen: 'Izhod iz celozaslonskega načina',
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: 'Izberi barvo z zaslona',
      hueSlider: 'Barvni odtenek',
      alphaSlider: 'Alfa',
      redInput: 'Rdeča',
      greenInput: 'Zelena',
      blueInput: 'Modra',
      alphaInput: 'Alfa',
      hueInput: 'Barvni odtenek',
      saturationInput: 'Nasičenost',
      lightnessInput: 'Svetlost',
      hexInput: 'HEX vrednost',
      hexaInput: 'HEX z alfa vrednostjo',
      changeFormat: 'Spremeni format barve',
    },
  },
}
